import { Nav } from "react-bootstrap";

import "./socialMediaButtonStyles.css";

const SocialMediaButton = ({ logo, link, styles }) => {
  return (
    <Nav.Link
      href={link}
      className={`${styles} social-media-button d-flex align-items-center justify-content-center`}
      target="_blank"
      rel="noopener noreferrer"
    >
      {logo}
    </Nav.Link>
  );
};

export default SocialMediaButton;
